<label *ngIf="label" class="col-form-label label-common">{{label}}<span class="text-danger">{{required ? ' *' : ''}}</span></label>
<input [typeahead]="states" typeaheadOptionField="name" (typeaheadOnSelect)="onSelect($event)"
       class="form-control" [typeaheadMinLength]="0" (blur)="onBlur($event)" [required]="required" [typeaheadScrollable]="true"
       [formControl]="inputControl" (ngModelChange)="changeCodeValue($event)"  (input)="onInputChange()"
       (focusout)="onFocusout()" [autofocus]="true" maxlength="150" autocomplete="off"
[class.is-invalid]="parentControl && parentControl.touched && parentControl.invalid && validationMessage" id={{autoFieldId}}/>
<div class="invalid-feedback" *ngIf="parentControl && parentControl.invalid && validationMessage" [attr.id]="autoFieldId + '-invalid'">
    {{validationMessage}}
</div>
